import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import EditIcon from "@material-ui/icons/Edit";
import TableHead from "@material-ui/core/TableHead";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import EditNumberStatusSelectTable from "./EditNumberStatusSelectTable";
import { fetchWithToken } from "../../../../apiUtils";

const headCells = [
  { id: "id", label: "ID" },
  { id: "name", label: "Pool" },
  { id: "startNumber", label: "Start" },
  { id: "endNumber", label: "End" },
  { id: "totalCount", label: "Total Count" },
  { id: "availableCount", label: "Available Count" },
];

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator, domain) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function RangesTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding="50px"
            style={{ fontSize: "20px", padding: "5px" }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: "20px", padding: "5px" }}
        >
          Edit
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

const EditNumberStatusTable = (props) => {
  const {
    classes,
    ranges,
    sites,
    statuses,
    phoneNumbers,
    setPhoneNumberValue,
    setPhoneNumbers,
    setSelectedNumbers,
    selectedNumbers,
    setSearchDetails,
    searchDetails,
    setNewRangeRequired,
  } = props;

  const [rangeDetails, setRangeDetails] = useState(null);

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const setRangeHandler = (row) => {
    setPhoneNumbers([]);
    setSelectedNumbers([]);
    setPhoneNumberValue("");
    fetchWithToken(`api/PhoneNumbers/ByRange/${row.id}`)
      .then((response) => response.json())
      .then((data) => {
        setPhoneNumbers(data);
      });
    setSearchDetails({
      display: true,
      site: sites.filter((s) => s.id == row.siteId)[0].name,
      pool: row.name,
      startNum: row.startNumber,
      endNum: row.endNumber,
    });
    setRangeDetails(row);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <RangesTableHead
                order={order}
                setPage={setPage}
                orderBy={orderBy}
                classes={classes}
                rowCount={ranges.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {stableSort(ranges, getComparator(order, orderBy), orderBy)
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={row.id}
                        style={{
                          height: "60px",
                          background: index % 2 ? "#f8f8f8" : "white",
                        }}
                      >
                        <TableCell align="center" style={{ width: "10%" }}>
                          {row.id}
                        </TableCell>
                        <TableCell align="center" style={{ width: "20%" }}>
                          {row.name}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.startNumber}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.endNumber}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.totalCount}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          {row.availableCount}
                        </TableCell>
                        <TableCell align="center" style={{ width: "10%" }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setRangeHandler(row)}
                          >
                            <EditIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {ranges.length <= 0 && (
                  <TableRow style={{ height: 60 }}>
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={ranges.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
            onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
            onPageChange={handleChangePage} // Material v > 4
            onChangePage={handleChangePage} // Material v < 4
          />
        </Paper>
      </div>
      {phoneNumbers.length > 0 && (
        <div className={classes.table}>
          <EditNumberStatusSelectTable
            classes={classes}
            statuses={statuses}
            phoneNumbers={phoneNumbers}
            selectedNumbers={selectedNumbers}
            setSelectedNumbers={setSelectedNumbers}
            searchDetails={searchDetails}
            rangeDetails={rangeDetails}
            setNewRangeRequired={setNewRangeRequired}
          />
        </div>
      )}
    </>
  );
};

export default EditNumberStatusTable;
